import EventBus from '@/EventBus';
import DefaultImageProps from '@/components/DesignObjects/ImageObject';
import { uuid } from 'vue-uuid';
import { getMaxZIndex } from '@/components/Helper';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';
import {
  findObjectById,
  getPropertyApplyTargets,
  isSvgStrokeObject,
} from '@/components/Canvas/utils/groupHelpers';

export default {
  methods: {
    getImagePropertyTargets() {
      const list = this.contentList || this.objectList;
      const topLevel = (typeof this.getSelectedTopLevelObjects === 'function')
          ? this.getSelectedTopLevelObjects()
          : null;
      return getPropertyApplyTargets(
          list,
          this.selectedObjectsList,
          this.activeObject,
          topLevel,
      );
    },
    findActiveObjectOnCanvas(objectId) {
      return findObjectById(this.contentList, objectId)
          || findObjectById(this.objectList, objectId);
    },
    removeObjectFromCanvas() {
      console.log('Deleting object');
      const index = parseInt(this.targets[0].dataset.elementindex);
      // EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.CLEARED);
      EventBus.$emit(ApplicationEventTypes.ModalEvents.TOGGLE_CONFIRMATION_MODAL, { request: 'DeleteReq', data: index, message: 'Are you sure you want to delete this?' });
    },

    changeFdicPhoto({ title, type }) {
      if (!this.activeObject || (title !== 'White' && title !== 'Black')) { return; }

      const targets = this.getImagePropertyTargets();
      if (targets.length) {
        targets.forEach((object) => {
          const selectedObject = findObjectById(this.contentList, object.Id) || object;
          selectedObject.isGradient = false;
          if (title === 'White') {
            this.changeSvgFillColor('#FFFFFF', selectedObject.Id);
          }
          if (title === 'Black') {
            this.changeSvgFillColor('#000000', selectedObject.Id);
          }
        });
      }

      this.emitUndoRedoRequest('Called by FDIC change');
    },
    changeHousingPhoto(data) {
      if (!this.activeObject || (data !== 'White' && data !== 'Black')) { return; }

      const targets = this.getImagePropertyTargets();
      if (targets.length) {
        targets.forEach((object) => {
          const selectedObject = findObjectById(this.contentList, object.Id) || object;
          selectedObject.isGradient = false;
          if (data === 'White') {
            this.changeSvgFillColor('#FFFFFF', selectedObject.Id);
          }
          if (data === 'Black') {
            this.changeSvgFillColor('#000000', selectedObject.Id);
          }
        });
      }

      this.emitUndoRedoRequest('Called by Equal Housing change');
    },
    resolveReplaceImageTarget() {
      if (!this.activeObject) { return null; }

      let target = null;
      if (this.activeObject.ImageType === 'Image') {
        target = this.activeObject;
      } else if (this.activeObject.type === 'group') {
        const fromList = (this.selectedObjectsList || []).find(obj => obj && obj.ImageType === 'Image');
        const child = fromList
            || (this.activeObject.children || []).find(obj => obj && obj.ImageType === 'Image');
        if (child) {
          target = child;
        }
      }

      if (!target) {
        const fromTargets = this.getImagePropertyTargets()
            .find(obj => obj && obj.ImageType === 'Image');
        if (fromTargets) {
          target = fromTargets;
        }
      }

      return target
          ? (this.findActiveObjectOnCanvas(target.Id) || target)
          : null;
    },
    replaceCanvansPhoto(scr) {
      const target = this.resolveReplaceImageTarget();
      if (!target || target.ImageType !== 'Image') { return; }

      const targetId = target.Id;
      const activeObjectElement = document.querySelector(`[id='${targetId}']`);
      const preservedEffects    = target.effects ? JSON.parse(JSON.stringify(target.effects)) : null;
      const preservedEffect     = target.effect;
      const preservedBlurEdges  = target.blurEdges ? JSON.parse(JSON.stringify(target.blurEdges)) : null;
      const preservedMaskStyle  = activeObjectElement ? {
        maskImage:          activeObjectElement.style.maskImage,
        maskRepeat:         activeObjectElement.style.maskRepeat,
        maskPosition:       activeObjectElement.style.maskPosition,
        maskSize:           activeObjectElement.style.maskSize,
        maskOrigin:         activeObjectElement.style.maskOrigin,
        webkitMaskImage:    activeObjectElement.style.WebkitMaskImage,
        webkitMaskRepeat:   activeObjectElement.style.WebkitMaskRepeat,
        webkitMaskPosition: activeObjectElement.style.WebkitMaskPosition,
        webkitMaskSize:     activeObjectElement.style.WebkitMaskSize,
        webkitMaskOrigin:   activeObjectElement.style.WebkitMaskOrigin,
      } : null;

      const img  = new Image();
      img.onload = () => {
        const live = this.findActiveObjectOnCanvas(targetId) || target;
        live.DefaultImageHeight = img.height;
        live.DefaultImageWidth  = img.width;
      };
      img.src       = scr.DefaultImageUrl;
      const hasCrop = target.croppedSrc !== 'none';

      target.DefaultImageUrl = scr.DefaultImageUrl;
      target.HighResPath     = scr.HighResImageUrl;
      target.HighResV2Height = scr.HighResV2Height;
      target.HighResV2Width  = scr.HighResV2Width;

      target.croppedHighResPath = hasCrop ? scr.HighResImageUrl : 'none';
      target.croppedSrc         = hasCrop ? scr.DefaultImageUrl : 'none';
      if (preservedEffects) {
        target.effects = preservedEffects;
      }
      if (preservedBlurEdges) {
        target.blurEdges = preservedBlurEdges;
      }
      if (preservedEffect === 'blurEdges' && preservedMaskStyle) {
        setTimeout(() => {
          const currentElement = document.querySelector(`[id='${targetId}']`);
          if (!currentElement) { return; }
          currentElement.style.maskImage          = preservedMaskStyle.maskImage;
          currentElement.style.maskRepeat         = preservedMaskStyle.maskRepeat;
          currentElement.style.maskPosition       = preservedMaskStyle.maskPosition;
          currentElement.style.maskSize           = preservedMaskStyle.maskSize;
          currentElement.style.maskOrigin         = preservedMaskStyle.maskOrigin;
          currentElement.style.WebkitMaskImage    = preservedMaskStyle.webkitMaskImage;
          currentElement.style.WebkitMaskRepeat   = preservedMaskStyle.webkitMaskRepeat;
          currentElement.style.WebkitMaskPosition = preservedMaskStyle.webkitMaskPosition;
          currentElement.style.WebkitMaskSize     = preservedMaskStyle.webkitMaskSize;
          currentElement.style.WebkitMaskOrigin   = preservedMaskStyle.webkitMaskOrigin;
        }, 0);
      }

      this.addIntoPageWiseUndoRedoArray_MixinFun('Replace image');
    },
    changeSvgFillColorBK(color) { // deleteable temporary function backup
      console.log('Changing SVG Image fill');
      if (color && this.activeObject != null && this.activeObject.type === 'image' && this.activeObject.ImageType === 'SVGImage' && !this.activeObject.isGradient) {
        const svgElement = document.querySelector(`[id='${this.activeObject.Id}'] svg`);
        this.removingStylingFromChildrenTag(svgElement, 'fill');
        if (svgElement) { svgElement.setAttribute('fill', color); }
        this.activeObject.SvgProperty.DefaultColor = color;
        const lines                                = svgElement.querySelectorAll('rect, ellipse, line, path, polygon');
        if (lines.length) {
          for (let lineIndex = 0; lineIndex < lines.length; lineIndex += 1) {
            lines[lineIndex].style.fill = color;
          }
        }
        this.activeObject.SvgProperty.content = svgElement.outerHTML;
        EventBus.$emit('updateProductColor');
        this.addIntoPageWiseUndoRedoArray_MixinFun('change SVG shape color');
      } else {
        const svgElement = document.querySelector(`[id='${this.activeObject.Id}'] svg`);
        if (!svgElement) { return; }
        this.removingStylingFromChildrenTag(svgElement, 'fill');

        let defs = svgElement.querySelector('defs');
        if (!defs) {
          defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
          svgElement.insertBefore(defs, svgElement.firstChild);
        }

        const gradientId = `gradient-${this.activeObject.Id}`;
        let gradient     = svgElement.querySelector(`#${gradientId}`);

        if (!gradient) {
          gradient = document.createElementNS('http://www.w3.org/2000/svg', 'linearGradient');
          gradient.setAttribute('id', gradientId);
          gradient.setAttribute('gradientTransform', `rotate(${this.activeObject.gradient.angle})`);
          defs.appendChild(gradient);
        } else {
          gradient.setAttribute('gradientTransform', `rotate(${this.activeObject.gradient.angle})`);
          gradient.innerHTML = '';
        }

        const sortedColors = this.activeObject.gradient.colors.sort((a, b) => a.position - b.position);
        sortedColors.forEach(({ position, rgba }) => {
          const stop = document.createElementNS('http://www.w3.org/2000/svg', 'stop');
          stop.setAttribute('offset', `${position}%`);
          stop.setAttribute('stop-color', rgba);
          gradient.appendChild(stop);
        });

        const elementsToStyle = svgElement.querySelectorAll('rect, ellipse, line, path, polygon');
        elementsToStyle.forEach((el) => {
          el.setAttribute('fill', `url(#${gradientId})`);
        });

        this.activeObject.SvgProperty.content = svgElement.outerHTML;
        EventBus.$emit('updateProductColor');
        this.addIntoPageWiseUndoRedoArray_MixinFun('change SVG shape color');
      }
    },
    changeSvgFillColor(color, objectId = '') {
      let selectedObject = this.activeObject;
      if (objectId != '') {
        selectedObject = findObjectById(this.contentList, objectId);
      }
      if (!selectedObject) { return; }
      if (color && selectedObject != null && selectedObject.type === 'text' && selectedObject.isGradient) {
        this.curveText();
      }
      if (color && selectedObject != null && selectedObject.type === 'image' && (selectedObject.ImageType === 'SVGImage' || selectedObject.ImageType.indexOf('FDICText') !== -1 || selectedObject.ImageType.indexOf('FDICLogo') !== -1) && !selectedObject.isGradient) {
        const svgElement = document.querySelector(`[id='${selectedObject.Id}'] svg`);
        this.removingStylingFromChildrenTag(svgElement, 'fill');
        if (svgElement) { svgElement.setAttribute('fill', color); }
        selectedObject.SvgProperty.DefaultColor = color;
        const lines                             = svgElement.querySelectorAll('rect, ellipse, line, path, polygon');
        if (lines.length) {
          for (let lineIndex = 0; lineIndex < lines.length; lineIndex += 1) {
            lines[lineIndex].style.fill = color;
          }
        }
        selectedObject.SvgProperty.content = svgElement.outerHTML;
        setTimeout(() => {
          if (selectedObject.effect && selectedObject.effect === 'shadow') {
            const elem = document.querySelector(`.canvas-main-html-container [id='${selectedObject.Id}']`);
            if (elem) {
              const newFilter   = `drop-shadow(${selectedObject.shadow.shadowOffsetX}px ${selectedObject.shadow.shadowOffsetY}px ${selectedObject.shadow.blur * 40}px ${selectedObject.shadow.color})`;
              elem.style.filter = newFilter;
            }
          }
        });
        // EventBus.$emit('updateProductColor');
        this.addIntoPageWiseUndoRedoArray_MixinFun('change SVG shape color');
      } else {
        if (!selectedObject || !selectedObject.gradient || !selectedObject.gradient.colors) { return; }
        const svgElement = document.querySelector(`[id='${selectedObject.Id}'] svg`);
        if (!svgElement) { return; }
        this.removingStylingFromChildrenTag(svgElement, 'fill');

        let defs = svgElement.querySelector('defs');
        if (!defs) {
          defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
          svgElement.insertBefore(defs, svgElement.firstChild);
        }

        defs.innerHTML = '';

        const gradientId = `gradient-${selectedObject.Id}`;
        let gradient     = svgElement.querySelector(`#${gradientId}`);

        if (!gradient) {
          gradient = document.createElementNS('http://www.w3.org/2000/svg', 'linearGradient');
          gradient.setAttribute('id', gradientId);
          gradient.setAttribute('gradientTransform', `rotate(${selectedObject.gradient.angle})`);
          defs.appendChild(gradient);
        } else {
          gradient.setAttribute('gradientTransform', `rotate(${selectedObject.gradient.angle})`);
          gradient.innerHTML = '';
        }

        const sortedColors = selectedObject.gradient.colors
          .slice()
          .sort((a, b) => Number(a.position) - Number(b.position));
        sortedColors.forEach(({ position, rgba }) => {
          const stop = document.createElementNS('http://www.w3.org/2000/svg', 'stop');
          stop.setAttribute('offset', `${position}%`);
          stop.setAttribute('stop-color', rgba);
          gradient.appendChild(stop);
        });

        const elementsToStyle = svgElement.querySelectorAll('rect, ellipse, line, path, polygon');
        elementsToStyle.forEach((el) => {
          el.setAttribute('fill', `url(#${gradientId})`);
        });
        if (!selectedObject.SvgProperty) {
          this.$set(selectedObject, 'SvgProperty', {});
        }
        this.$set(selectedObject.SvgProperty, 'content', svgElement.outerHTML);
      }
    },

    changeSvgStrokeColor(color, objectId = '') {
      const targets = this.getImagePropertyTargets();
      const ids = new Set(
          targets
              .filter(object => object && object.Id)
              .map(object => object.Id),
      );
      if (objectId) { ids.add(objectId); }
      if (!ids.size) { return; }
      ids.forEach((id) => {
        this.changeSvgStrokeColorById(color, id);
      });
    },
    changeSvgStrokeColorById(color, objectId) {
      const selectedObject = this.findActiveObjectOnCanvas(objectId);
      console.log('Changing SVG Stroke ');
      console.log('color', color);
      if (!isSvgStrokeObject(selectedObject)) { return; }
      const svgElement = document.querySelector(`[id='${selectedObject.Id}'] svg`);
      if (!svgElement) { return; }
      this.removingStylingFromChildrenTag(svgElement, 'stroke');
      this.$set(selectedObject.SvgProperty, 'StrokeColor', color);
      const lines = svgElement.querySelectorAll('line, path, rect, ellipse, polygon');
      if (lines.length) {
        for (let lineIndex = 0; lineIndex < lines.length; lineIndex += 1) {
          lines[lineIndex].style.stroke      = color;
          lines[lineIndex].style.strokeWidth = selectedObject.ImageType && (selectedObject.ImageType.indexOf('FDICText') !== -1 || selectedObject.ImageType.indexOf('FDICLogo') !== -1) ? parseInt(selectedObject.SvgProperty.StrokeWidth, 10) / 10 : selectedObject.SvgProperty.StrokeWidth;
        }
      }

      selectedObject.SvgProperty.content = svgElement.outerHTML;
      this.addIntoPageWiseUndoRedoArray_MixinFun('change SVG shape color');
    },
     changeStrokeWidth(value, objectId = '') {
      const targets = this.getImagePropertyTargets();
      const ids = new Set(
          targets
              .filter(object => object && object.Id)
              .map(object => object.Id),
      );
      if (objectId) { ids.add(objectId); }
      if (!ids.size) { return; }
      ids.forEach((id) => {
        this.changeStrokeWidthById(value, id);
      });
    },
    changeStrokeWidthById(value, objectId) {
      const selectedObject = this.findActiveObjectOnCanvas(objectId);
      if (!selectedObject) { return; }
      if (isSvgStrokeObject(selectedObject)) {
        this.$set(selectedObject.SvgProperty, 'StrokeWidth', parseInt(value, 10));
        this.changeSvgStrokeColorById(selectedObject.SvgProperty.StrokeColor, objectId);
      } else if (selectedObject.type === 'shape') {
        this.$set(selectedObject, 'StrokeWidth', parseInt(value, 10));
      }
    },
    changeImageBorderInUI(value) {
      this.getImagePropertyTargets().forEach((object) => {
        const obj          = findObjectById(this.contentList, object.Id) || object;
        const elemSelector = `.canvas-non-play-all [id='${obj.Id}']`;
        const elem         = document.querySelector(elemSelector);
        if (!elem) { return; }

        let divider = 1;
        if (obj.ImageType == 'WhiteboxLogo') { divider = 5; }

        const style  = window.getComputedStyle(elem);
        const filter = style.filter;
        // console.log("Computed filter:", filter);

        let color = obj.outline && obj.outline.color ? obj.outline.color : 'black'; // fallback

        // Regex to capture color when it's FIRST inside drop-shadow()
        const dropShadowRegex = /drop-shadow\(\s*(#[0-9a-fA-F]{3,8}|rgba?\([^)]*\)|[a-zA-Z]+)\s/;

        const match = filter.match(dropShadowRegex);
        if (match) {
          [, color] = match;
        }

        console.log('Detected color:', color);

        // Build new directional shadows with current color
        const newDropShadows = value > 0 ? `
          drop-shadow(${color} ${value / divider}px 0 0)
          drop-shadow(${color} ${-value / divider}px 0 0)
          drop-shadow(${color} 0 ${value / divider}px 0)
          drop-shadow(${color} 0 ${-value / divider}px 0)
        `.trim() : '';

        elem.style.filter = newDropShadows;
      });
    },
    removingStylingFromChildrenTag(svgElement, type = 'stroke') {
      svgElement.querySelectorAll('path').forEach((item) => {
        if (type == 'stroke') { item.style.stroke = ''; }
        if (type == 'fill') { item.style.fill = ''; }
      });
      svgElement.querySelectorAll('g').forEach((item) => {
        if (type == 'stroke') { item.style.stroke = ''; }
        if (type == 'fill') { item.style.fill = ''; }
      });
    },
    replaceCanvansAddressBoxPhoto(AddressBoxesPath) {
      if (this.activeObject != null && (this.activeObject.ImageType === 'WhiteboxLogo' || this.activeObject.ImageType === 'IndependentWhitebox')) {
        this.activeObject.DefaultImageUrl = AddressBoxesPath.DefaultImagePath;
        this.activeObject.HighResPath     = AddressBoxesPath.HighResImagePath;
        setTimeout(() => { EventBus.$emit('updateProductColor'); }, 0);
        this.addIntoPageWiseUndoRedoArray_MixinFun('Replace Address Box image');
      }
    },
    addIntoPageWiseUndoRedoArray_MixinFun(data) {
      EventBus.$emit(ApplicationEventTypes.UndoRedoEvents.ADDED, data);
    },
    AddNewObjectImage(newImgData) {
      EventBus.$emit('showHideLoader', true);
      const productwidth  = this.width;
      const productheight = this.height;
      const { data }      = new DefaultImageProps();
      // const objectHeight   = 'auto';
      // const temp           = Math.min(this.width, this.height);
      data.ImageType       = 'Image';
      data.DefaultImageUrl = newImgData.DefaultImageUrl;
      data.HighResPath     = newImgData.HighResImageUrl || newImgData.DefaultImageUrl; // if highresource is null or empty then the default image replace the highe resource
      data.Name            = 'Photo';
      data.Id              = uuid.v1();
      data.PdfSortOrder    = data.SortOrder = getMaxZIndex(document.getElementById('canvas-wrapper').firstElementChild.children) + 1;
      // data.Width           = temp;
      // data.Height          = objectHeight;
      data.HighResV2Height               = newImgData.HighResV2Height;
      data.HighResV2Width                = newImgData.HighResV2Width;
      data.elementIndex                  = 0;
      data.isSelected                    = false;
      data.RotateDegree                  = 0;
      data.PageNo                        = this.activePage;
      data.isImageAddedOnCanvasFromModel = true;
      data.AlternativeImageUrlsResVersion.push(newImgData);
      const img = new Image();

      img.onload =  () => {
        // data.Height = temp * (img.height / img.width);
        // let widthRatio=img.width/img.height
        data.DefaultImageHeight = img.height;
        data.DefaultImageWidth  = img.width;
        const heightRatio       = img.height / img.width;
        data.Width              = productwidth / 1.5;
        data.Height             = Math.round(data.Width * heightRatio);
        data.X                  = Math.round(Math.abs((productwidth / 2) - data.Width / 2));
        data.Y                  = Math.round(Math.abs((productheight / 2) - data.Height / 2));
        EventBus.$emit('onObjectAdding', JSON.parse(JSON.stringify(data)));
        // EventBus.$emit('showHideLoader', false);
      };
      img.onerror = () => {
        // EventBus.$emit('showHideLoader', false);
      };
      img.src     = newImgData.DefaultImageUrl;
    },
    emitUndoRedoRequest(data) {
      EventBus.$emit('addIntoPageWiseUndoRedoArray', data);
    },
  },
};
